import { createAction } from 'redux-actions';
import { CompliantLocalStorageKeys, reduxKey } from './constants';

export interface CompliantLocalStoragePayload {
  key: CompliantLocalStorageKeys;
  value: string;
}

export const initializeCompliantLocalStorage = createAction(
  `${reduxKey}/INITIALIZE_COMPLIANT_LOCAL_STORAGE`,
  () => ({})
);

export const setCompliantLocalStorageItem = createAction(
  `${reduxKey}/SET_ITEM`,
  (payload: CompliantLocalStoragePayload) => payload
);

export const removeCompliantLocalStorageItem = createAction(
  `${reduxKey}/REMOVE_ITEM`,
  (key: CompliantLocalStorageKeys) => ({ key })
);
